import React from 'react';
import PropTypes from 'prop-types';
import iconPaths from '../../../../static/selection.json';

function getIconData (iconName) {
    const icon = iconPaths.icons.find(icon => icon.properties.name === iconName);
    if (icon) {
        return icon;
    } else {
        console.warn(`icon ${iconName} does not exist.`);
        return null;
    }
}

const AppIcon = ({ style, ...props }) => {
    const iconData = getIconData(props.name);
    
    if (!iconData) {
        return null;
    }
    
    const { paths, attrs = [], width = 1024 } = iconData.icon;
    const viewBox = `0 0 ${width} 1024`;
    
    return (
        <svg
            width={`${props.size}px`}
            height={`${props.size}px`}
            viewBox={viewBox}
            className='custom-icon'
            preserveAspectRatio='xMaxYMax meet'
            style={{ ...style, overflow: 'visible' }}
            {...props}
        >
            {paths.map((path, index) => {
                const pathAttrs = attrs[index] || {};
                const fill = pathAttrs.fill || props.fill;
                
                return (
                    <path
                        key={index}
                        fill={fill}
                        d={path}
                        {...pathAttrs}
                    />
                );
            })}
        </svg>
    );
};

AppIcon.propTypes = {
    name: PropTypes.string.isRequired,
    fill: PropTypes.string,
    size: PropTypes.any,
    style: PropTypes.object
};

AppIcon.defaultProps = {
    size: 16,
    fill: 'black',
    style: {}
};

export const AppIconShowCase = () => (
    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
        {iconPaths.icons.map((icon) => icon.properties.name).map((name) => (
            <div key={`app-icon-${name}`} style={{ flex: '1 1 200px', margin: 10 }}>
                <AppIcon name={name} size={40} style={{ fill: 'black' }} />
                <p>{name}</p>
            </div>
        ))}
    </div>
);
export default AppIcon;